export interface PizzaSize {
	name: string; // broto, p, m, g, gg, gigante, etc
	slices: number;
	max_flavors: number;
	max_crust_flavors: number;
	packaging_price: number;
}
export interface PizzaCrust {
	name: string; // Catupiry, Chocolate, etc
	prices: {size_name: string, price: number}[];
  // set by front end
  sizePrice?: number;
}
export interface PizzaIngredient {
	name: string; // cebola, bacon, etc
	prices: {size_name: string, price: number}[];
  // set by front end
  sizePrice?: number;
}
export class PizzaConfig {
	sizes: PizzaSize[];
	crusts: PizzaCrust[];
	ingredients: PizzaIngredient[];
	flavor_categories: string[]; // Tradicionais, Premium, SuperPremium, Doces, etc
	multi_flavor_pricing: 'proportional'|'highest price';
	categories_mixing: 'all'|string; // separator is | and ; symbols. e.g.: 'Tradicionais|Premium;Tradicionais|SuperPremium'

	constructor(jsonData: any) {
		for(let key in jsonData) {
			this[key] = jsonData[key];
		}
	}

	newSize(idx?: number) {
		let size: PizzaSize = {
			name: '',
			slices: 4,
			max_flavors: 2,
			max_crust_flavors: 1,
			packaging_price: 0
		};
		if(idx != null) {
			this.sizes.splice(idx, 0, size);
		} else {
			this.sizes.push(size);
		}
	}

	removeSize(idx?: number) {
		if(idx != null) {
			this.sizes.splice(idx, 1);
		} else {
			this.sizes.splice(this.sizes.length - 1, 0);
		}
	}

	newCrust(idx?: number) {
		let crust: PizzaCrust = {
			name: '',
			prices: []
		};
		for(let size of this.sizes) {
			crust.prices.push({size_name: size.name, price: 99.99});
		}
		if(idx != null) {
			this.crusts.splice(idx, 0, crust);
		} else {
			this.crusts.push(crust);
		}
	}
	removeCrust(idx?: number) {
		if(idx != null) {
			this.crusts.splice(idx, 1);
		} else {
			this.crusts.splice(this.crusts.length - 1, 0);
		}
	}

	newIngredient(idx?: number) {
		let ingredient: PizzaIngredient = {
			name: '',
			prices: []
		};
		for(let size of this.sizes) {
			ingredient.prices.push({size_name: size.name, price: 99.99});
		}
		if(idx != null) {
			this.ingredients.splice(idx, 0, ingredient);
		} else {
			this.ingredients.push(ingredient);
		}
	}
	removeIngredient(idx?: number) {
		if(idx != null) {
			this.ingredients.splice(idx, 1);
		} else {
			this.ingredients.splice(this.ingredients.length - 1, 0);
		}
	}

	static defaultConfig(): PizzaConfig {
		return new PizzaConfig({
			sizes: [],
			crusts: [],
			ingredients: [],
			flavor_categories: [],
			multi_flavor_pricing: 'proportional',
			categories_mixing: 'all'
		})
	}
}
